import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/** Where a signed-in user lands: SuperAdmin has no operational data by default, so Organizations; everyone else Dashboard. */
export const homeRouteFor = (auth: AuthService): string => (auth.hasRole('SuperAdmin') ? '/admin/organizations' : '/dashboard');

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // A UrlTree replaces the blocked history entry, so Back from /login can't loop into the same blocked page.
  return auth.isAuthenticated() ? true : router.createUrlTree(['/login']);
};

/** For anonymous-only pages (login, register, forgot-password): an authenticated user is sent to their home route. */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isAuthenticated() ? router.createUrlTree([homeRouteFor(auth)]) : true;
};
